<template>
  <section v-if="error" class="error-holder flex items-end">
    <svg
      width="28"
      height="30"
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4455 7.89792C12.6172 5.99544 15.3828 5.99543 16.5545 7.89792L23.308 18.8644C24.539 20.8631 23.101 23.4375 20.7536 23.4375H7.24642C4.89901 23.4375 3.46104 20.8631 4.69197 18.8644L11.4455 7.89792Z"
        fill="#CE3C3C"
      />
      <path
        d="M14.25 11.2727L14.1648 17.5455H13.1761L13.0909 11.2727H14.25ZM13.6705 20.0682C13.4602 20.0682 13.2798 19.9929 13.1293 19.8423C12.9787 19.6918 12.9034 19.5114 12.9034 19.3011C12.9034 19.0909 12.9787 18.9105 13.1293 18.7599C13.2798 18.6094 13.4602 18.5341 13.6705 18.5341C13.8807 18.5341 14.0611 18.6094 14.2116 18.7599C14.3622 18.9105 14.4375 19.0909 14.4375 19.3011C14.4375 19.4403 14.402 19.5682 14.331 19.6847C14.2628 19.8011 14.1705 19.8949 14.054 19.9659C13.9403 20.0341 13.8125 20.0682 13.6705 20.0682Z"
        fill="#F5F2EE"
      />
    </svg>

    <small> {{ errorMessage }} </small>
  </section>
</template>

<script>
export default {
  name: 'ErrorDisplay',

  props: {
    error: {
      type: Boolean,
      default: true
    },
    errorMessage: {
      type: String,
      default: '',
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
small {
  color: #ce3c3c;
  font-weight: 600;
  padding-bottom: 0.2rem;
  font-size: 0.698rem;
}
</style>
